document.addEventListener('DOMContentLoaded', (e) => {
  const accordions = document.querySelectorAll('[data-faq-card]');

  accordions.forEach((item) => {
    const title = item.querySelector('[data-faq-card-title]');
    title.addEventListener('click', () => item.classList.toggle('is_opened'));
  });
});

// const openAccordion = (el) => el.classList.add('is_opened');
// const closeAccordion = (el) => el.classList.remove('is_opened');

// const accordions = document.querySelectorAll('[data-faq-card]');

// accordions.forEach((accordion) => {
//   const trigger = accordion.querySelector('[data-faq-card-title]');

//   trigger.addEventListener('click', (e) => {
//     if (accordion.classList.contains('is_opened')) {
//       closeAccordion(accordion);
//       return;
//     }

//     accordions.forEach((accordion) => closeAccordion(accordion));
//     openAccordion(accordion);
//   });
// });

// openAccordion(accordions[0]);
